import { AnimatePresence, motion } from "framer-motion";
import { X, Star, Check } from "lucide-react";
import { resolveImg } from "@/lib/api";

export const ProductModal = ({ product, content, onClose }) => {
  return (
    <AnimatePresence>
      {product && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="product-modal"
          className="fixed inset-0 z-[70] flex items-center justify-center p-4 md:p-8"
          onClick={onClose}
        >
          <div className="absolute inset-0 bg-forest-900/60 backdrop-blur-sm" />
          <motion.div
            initial={{ y: 40, opacity: 0, scale: 0.98 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 40, opacity: 0, scale: 0.98 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative z-10 w-full max-w-4xl bg-sand rounded-3xl overflow-hidden grid md:grid-cols-2 max-h-[90vh]"
          >
            <div className="relative bg-forest-900 flex items-center justify-center max-h-[45vh] md:max-h-[90vh] overflow-hidden">
              <img src={resolveImg(product.image)} alt={product.name} className="w-full h-full object-contain" />
            </div>
            <div className="p-8 md:p-10 overflow-y-auto">
              <button
                data-testid="modal-close-btn"
                onClick={onClose}
                className="absolute top-4 right-4 h-10 w-10 rounded-full bg-sand/90 md:bg-forest-900/10 flex items-center justify-center hover:bg-terracotta-500 hover:text-white transition-colors"
              >
                <X size={20} />
              </button>
              <span className="text-xs tracking-[0.2em] uppercase font-semibold text-terracotta-500">{product.category}</span>
              <h3 className="font-serif text-3xl md:text-4xl text-forest-900 mt-3 leading-tight">{product.name}</h3>
              <div className="flex items-center gap-1.5 text-terracotta-500 mt-3">
                <Star size={15} fill="currentColor" />
                <span className="text-sm font-semibold text-forest-700">{product.rating} / 5</span>
              </div>
              <p className="text-forest-700/80 leading-relaxed mt-5">{product.description}</p>

              {product.tags?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-5">
                  {product.tags.map((t) => (
                    <span key={t} className="flex items-center gap-1.5 rounded-full bg-forest-50 text-forest-800 px-3 py-1.5 text-xs font-medium">
                      <Check size={13} className="text-sage-500" /> {t}
                    </span>
                  ))}
                </div>
              )}

              <div className="flex items-center justify-between mt-8 pt-6 border-t border-forest-900/10">
                <div className="font-serif text-4xl text-forest-900">${product.price.toFixed(2)}</div>
                <a
                  data-testid="modal-order-btn"
                  href={`https://wa.me/${content.whatsapp_number}?text=${encodeURIComponent(
                    `Hola Vegonia, quiero pedir: ${product.name} ($${product.price.toFixed(2)})`
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full bg-forest-900 text-sand px-7 py-3.5 text-sm font-semibold hover:bg-terracotta-500 transition-colors"
                >
                  Pedir por WhatsApp
                </a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
